import { render } from "./Unauthorized.vue?vue&type=template&id=1034b706&scoped=true&ts=true"
import script from "./Unauthorized.vue?vue&type=script&lang=ts"
export * from "./Unauthorized.vue?vue&type=script&lang=ts"

import "./Unauthorized.vue?vue&type=style&index=0&id=1034b706&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1034b706"]])

export default __exports__